import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Tab, Tabs, Form, Row, Col } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPlus, faCircleXmark, faTrashCan, faPencil, faEnvelope, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { Prev } from 'react-bootstrap/esm/PageItem';
import Arcv from "../../../assets/images/archive.svg";
import Active from "../../../assets/images/active.svg";
import ImageUpload from '../../../Components/common/ImageUpload.js';

import { toast } from 'react-toastify';
import Trash from "../../../assets/images/trash.png";
import edit from "../../../assets/images/edit.png";
import { CallApi, jqxCookieCall } from '../../../Components/common/CommonFunctions.js';
import ConfModal from '../../../Components/common/ConfModal.js';

const AgentDetails = ({ stnData, reload }) => {


    // console.log('999', stnData);
    const isMounted = useRef(false);
    const [formData, setFormData] = useState({});
    const [showAgentModal, setShowAgentModal] = useState(false);
    const [modalConf, setModalConf] = useState(false);
    const [confData, setConfData] = useState({});

    const [isLoading, setIsLoading] = useState(true);
    const [gridData, setGridData] = useState({
        Active: [],
        Archived: []

    });

    useEffect(() => {
        if (isMounted.current) return;
        setIsLoading(false);
        setGridData({ Active: {} })
        isMounted.current = true;
    }, []);
    const [activeTab, setActiveTab] = useState('Active');
    const [filterApplied, setFilterApplied] = useState(false);
    const [gridSelect, setGridSelect] = useState([]);

    const gridRefs = {
        Active: useRef(null),
        Archived: useRef(null)
    };

    const handleTabChange = (tab) => {
        setIsLoading(true);
        setActiveTab(tab);
        setGridSelect([])
        if (tab == 'Active') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Active: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archived: {} });
            }, 1);
        }
    };

    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRefs[activeTab].current) {
            // var token = "Bearer " + localStorage.ULD;
            jqxCookieCall();
            const tabType = activeTab == 'Active' ? 'A' : 'R';

            const source = {
                datatype: 'json',
                id: `${activeTab}-`,
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'agent_name', type: 'string' },
                    { name: 'agent_code', type: 'string' },

                ],
                url: `${process.env.REACT_APP_RFS_URL}handler-agent-settings/get-station-agent?station_id=${stnData.station_id}&tab=${tabType}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 10,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");

                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;

                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };

            const dataAdapter = new window.$.jqx.dataAdapter(source);
            // console.log('localdata', source.localdata)
            const columns = [
                // { text: 'id', filtertype: 'textbox', datafield: 'id', width: '40%' },
                {
                    text: 'Actions',
                    cellsrenderer: function () {
                        return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /> <img src="' + Trash + '" class="row_delete" /></div>';
                    },
                    width: '10%', filterable: false,
                },
                { text: 'Agent Name', filtertype: 'textbox', datafield: 'agent_name', width: '40%', cellclassname: '', },
                { text: 'Agent Code', filtertype: 'textbox', datafield: 'agent_code', width: '40%', cellclassname: '', },
                // {
                //     text: 'External/Internal', filtertype: 'textbox', datafield: 'regd',
                //     cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                //         if (cellValue === 'E') {
                //             return '<div class="s_register"> External </div>';
                //         } else if (cellValue === 'I') {
                //             return '<div class="s_nonregister"> Internal </div>';
                //         } else {
                //             return '<div class="s_nonregister"> </div>';
                //         }
                //     },
                //     width: '28%', cellclassname: 'frcl',
                // },
            ];

            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: true,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 10,
                pagerButtonsCount: 5,
                // pagerMode: 'advanced', 
                pagesizeoptions: ['10', '20', '50', '100'],
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
            };

            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');

            window.$(gridRefs[activeTab].current).off('cellclick');
            window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex > 1) {
                    // setSelectedRowData(args);
                }
            });
            // window.$(gridRefs[activeTab].current).on('rowclick', (event) => {
            //     // console.log('event', event);
            //     const args = event.args.row.bounddata;
            //     console.log('args', args);
            //     if (args?.agent_codes?.length) {
            //         const agentCodeList = args.agent_codes.map(code => ({
            //             id: code.id,
            //             agent_code: code.agent_code
            //         }));
            //         setAgentCodes(agentCodeList);
            //     } else {
            //         setAgentCodes([]);
            //     }
            //     const sendRowId = gridData[activeTab];
            //     // console.log("🚀 ~ window.$ ~ sendRowId:", sendRowId)
            //     setSelectedRowData(args, { station_id: args.uid });

            //     setItems(args.recovery_emails)
            //     setShowDetails(true);
            //     const transformedData = {
            //         ...args,
            //         agent_type: args.regd,
            //         // email: args.contact_email
            //     };
            //     setSelectedAddress(transformedData);
            //     setEmailShow(false);
            // });
            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            // row selection by checkbox
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const selectedRowId = selectedRow.id;
                    if (!gridSelect.some(row => row.id === selectedRowId)) {
                        setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    }
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                        console.log('allIds', allIds);

                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.id !== unselectedRowId));
                }
            });

            window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;

                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        // console.log('Edit Row Data:', rowData);
                        setFormData({ agent_code: rowData.agent_code, agent_name: rowData.agent_name, agent_id: rowData.id });
                        setShowAgentModal(true)
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('click', '.row_delete', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;

                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        // console.log('Edit Row Data:', rowData);
                        // setFormData({ agent_id: rowData.id });
                        setConfData({
                            header: 'Remove Agent',
                            subHeader: 'Are you sure you want to remove this Agent?',
                            modalConf: () => deleteAgent(rowData.id),
                            primaryBtn: 'Yes',
                            secondaryBtn: 'No',
                        })
                        setModalConf(true)
                    }
                }
            });
        }
    }, [gridData]);
    // console.log('101', gridSelect);
    // row click function start
    const handleMoveToActArc = () => {
        setConfData({
            header: `${activeTab === 'Active' ? 'Archive' : 'Active'} Agent`,
            subHeader: `Are you sure you want to ${activeTab === 'Active' ? 'Archive' : 'Active'} this Agent?`,
            modalConf: confMoveToActArc,
            primaryBtn: 'Yes',
            secondaryBtn: 'No',
        })
        setModalConf(true)
    }
    const confMoveToActArc = () => {
        // console.log('101', gridSelect);
        if (gridSelect.length <= 0) {
            toast.error('Please select grid data before send');
            return;
        }
        const sendAction = activeTab == 'Active' ? '0' : '1';

        const uldNumbers = gridSelect && gridSelect.map(num => num.id)
        CallApi({
            endPoint: 'handler-agent-settings/toggle-active-archive',
            payload: { handler_uld_agents_ids: uldNumbers, action: sendAction },
            onSuccess: (data) => {
                // console.log('sendData', data);
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    gridSelect.forEach(item => {
                        const selectedRowBoundIndex = item.boundindex;
                        window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                    });
                    window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                } else {
                    toast.error(data.response_msg);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }

    const handleOpenModal = () => {
        setFormData({})
        setShowAgentModal(true);
    }

    const handleModalClose = () => {
        setShowAgentModal(false);
    };

    const agentChange = (e) => {
        const { name, value } = e.target
        setFormData({ ...formData, [name]: value })
    }

    const handleAddAgent = () => {
        CallApi({
            endPoint: 'handler-agent-settings/save-agent',
            payload: { ...formData, station_id: stnData.station_id },
            onSuccess: (data) => {
                // console.log('sendData', data);
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                    // reload()
                } else {
                    toast.error(data.response_msg);
                }
                handleModalClose()
            },
            onError: (msg) => toast.error(msg)
        });
    }
    const deleteAgent = (id) => {
        CallApi({
            endPoint: 'handler-agent-settings/delete-restore',
            payload: { id: id },
            onSuccess: (data) => {
                // console.log('sendData', data);
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                    // reload()
                } else {
                    toast.error(data.response_msg);
                }
                setModalConf(false)
            },
            onError: (msg) => toast.error(msg)
        });
    }

    return (
        <>
            {console.log('gridSelect', gridSelect)}
            {console.log('formData', formData)}
            {/* <div className='col-9 col-xxl-9 stting_right'>
                <div className='settingbg_right'> */}
            {modalConf &&
                <ConfModal
                    header={confData.header}
                    subHeader={confData.subHeader}
                    modalConf={confData.modalConf}
                    closeModal={() => setModalConf(false)}
                    primaryBtn={'Yes'}
                    secondaryBtn={'No'}
                />
            }
            <Row className='mt-3'>
                <Col className='pt-4 px-4 brd_rgt' lg="6">
                    <h4>Agent Settings</h4>
                    <p>Add stations and manage stations by selecting the station.</p>
                    <div>
                        <button onClick={handleOpenModal} className={'exportbtn me-3 active mb-2'}>
                            <span> <FontAwesomeIcon icon={faPlus} /> Add Agent</span>
                        </button>
                    </div>
                    <div className='addresses'>
                        <Tabs defaultActiveKey={activeTab} onSelect={(tab) => handleTabChange(tab)} id="station-tabs" className="station_grid">
                            <Tab eventKey="Active" title={<span>Active</span>} className='moveto'>
                                <div className='moveto_btn'>
                                    <button onClick={handleMoveToActArc}> <img src={Arcv} /></button>
                                </div>
                                {!isLoading && <>
                                    <div ref={gridRefs.Active} className='staion_grid' ></div>
                                </>}
                            </Tab>
                            <Tab eventKey="Archived" title={<span>Archived</span>} className='moveto'>
                                <div className='moveto_btn'>
                                    <button onClick={handleMoveToActArc}> <img title='' src={Active} /></button>
                                </div>
                                {!isLoading && <>
                                    <div ref={gridRefs.Archived} className='staion_grid' ></div>
                                </>}
                            </Tab>
                        </Tabs>
                    </div>
                </Col>
            </Row>

            <Modal show={showAgentModal} centered onHide={handleModalClose} className='addfrom staion_add' >
                <Modal.Header closeButton>
                    <Modal.Title>{formData.agent_name ? 'Edit' : 'Add'} Agent - Station {stnData?.station_name}</Modal.Title>
                    <p>{formData.agent_name ? 'Edit' : 'Add'} Agent for the station {stnData.station_code}.</p>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className='mb-2'>
                        <Form.Label>Agent Name</Form.Label>
                        <Form.Control type="text" name='agent_name' value={formData.agent_name} placeholder="Agent Name" onChange={agentChange} />
                    </Form.Group>
                    <Form.Group className='mb-2'>
                        <Form.Label>Agent Code</Form.Label>
                        <Form.Control type="text" name='agent_code' value={formData.agent_code} placeholder="Agent Code" onChange={agentChange} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleAddAgent}>{formData.agent_name ? 'Update' : 'Add'} Agent</Button>
                </Modal.Footer>
            </Modal>
            {/* </div>
            </div> */}
        </>
    )
}

export default AgentDetails